import { Component, ElementRef, Inject } from "@angular/core";
import { NgbActiveModal, NgbModalRef, NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { FormGroup, FormControl, FormBuilder, Validators } from "@angular/forms";
import { Router } from "@angular/router";
import * as jQuery from "jquery";
import { DataService } from "../../../services/data/data.service";
import { LoginRequestModel } from "../../../model/login.request.data";
import { CookiesService } from "../../../tools/cookies.service";
import { TradeRequestModel } from "../../../model/trade.request.data";
import { Subscription } from "rxjs";
import { LoginRs } from "../../../interfaces/service.response";

import * as $ from "jquery";
import { WorkspaceServiceService } from "../../../services/workspace-service.service";
import { _ } from "ag-grid";
import { waitForMap } from "@angular/router/src/utils/collection";
import { Utils } from "../../../utils";
import { UserType } from "../../../enums/USerType.enum";
import { Providers } from '../../../enums/providers';

declare function myMethod(): any;
export declare var fbq: Function;

@Component({
    selector: "modal-login",
    template: require('./login.component.html'),
    styles: [require('./login.component.css')]
})
export class LoginModal {
    form!: FormGroup;
    protected subscription!: Subscription;

    constructor(
        protected router: Router,
        protected fb: FormBuilder,
        public activeModal: NgbActiveModal,
        protected modalService: NgbModal,
        protected dataService: DataService,
        public workspaceService: WorkspaceServiceService
    ) {
        console.log("SHOWLOGINCONSTRUCTOR");
        this.workspaceService.data.LoginModalCreated = true;

        this.workspaceService.data.loginError = false;

        this.form = this.fb.group({
            Username: [this.workspaceService.data.userName, Validators.required],
            Password: [this.workspaceService.data.userPassword, Validators.required],
            Provider: [this.currentProvider, Validators.nullValidator]
        });

        if (this.workspaceService.data.cookieService.getCookie("_r") !== undefined) {
            let t = this.workspaceService.data.cookieService.getCookie("_r");
            let u = this.workspaceService.data.cookieService.getCookie("_xu");
            let p = this.workspaceService.data.cookieService.getCookie("_zp");
            let pr = this.workspaceService.data.cookieService.getCookie("_provider");
            

            if (t == "1") {
                this.workspaceService.data.remember = true;
                this.userName = atob(u);
                this.userPassword = atob(p);
                this.currentProvider = (pr!="")?pr:"DEMO";
                
                this.form = this.fb.group({
                    Username: [this.userName, Validators.required],
                    Password: [this.userPassword, Validators.required],
                    Provider: [this.currentProvider, Validators.nullValidator]
                });
            } else {
                this.workspaceService.data.remember = false;
            }
        }

        // if (this.userName && this.userPassword && this.userName != "" && this.userPassword != "") {
        //     Utils.waitFor(
        //         () => this.dataService.conectionOpened,
        //         () => this.sendLogin(this.userName, this.userPassword)
        //     );
        //     this.activeModal.close();
        //     this.workspaceService.data.LoginModalCreated=false;
        // }

        /**FIX FOR "tolate" window render */
        let Interval = setInterval(() => {
            if (this.workspaceService.data.cookieService.getCookie("IsLoggedIn") == "true") {
                this.activeModal.close();
                this.workspaceService.data.LoginModalCreated = false;
                clearInterval(Interval);
            }
            //  console.log(this.cookieService.getCookie("IsLoggedIn"));
        }, 500);

        this.subscription = this.dataService.dataSubscriber.subscribe(response => {
            if (response) {
                switch (response.Type) {
                    case "LoginRs":
                        var loginRs: LoginRs = <LoginRs>response;
                        console.log('loginrs', loginRs);
                        // this.workspaceService.data
                        //     .ProcessLoginResponse(
                        //         loginRs,
                        //         this.userName,
                        //         this.userPassword,
                        //         this.workspaceService.data.remember
                        //     )
                        //     .then(() => {
                        //this.activeModal.close();
                        //     })
                        //     .catch(e => {
                        //         console.error(e);
                        //     });

                        if (loginRs.ApplicationUserType == "" || loginRs.ApplicationUserType == undefined) {
                            this.workspaceService.data.applicationUserType = UserType.Regular;
                        } else {
                            this.workspaceService.data.applicationUserType = (<any>UserType)[loginRs.ApplicationUserType];
                        }


                        break;
                }
            }
        });
    }

    public Providers = Providers


    private _currentProvider: string = Providers.DEMO;
    public get currentProvider(): string {
        return this._currentProvider;
    }
    public set currentProvider(value: string) {
        this._currentProvider = value;
    }

    get loginError() {
        return this.workspaceService.data.loginError;
    }

    set loginError(v: boolean) {
        this.workspaceService.data.loginError = v;
    }

    get userName(): string {
        return this.workspaceService.data.userName;
    }
    set userName(v: string) {
        this.workspaceService.data.userName = v;
    }

    get userPassword(): string {
        return this.workspaceService.data.userPassword;
    }
    set userPassword(v: string) {
        this.workspaceService.data.userPassword = v;
    }

    private _Provider: string = "DEMO";
    public get Provider(): string {
        return this._Provider;
    }
    public set Provider(value: string) {
        this._Provider = value;
    }


     public updateProviderFromSelector(selected:Providers)
    {
        console.log("SELECT UPDATE")
        console.log(selected);
        this.form.controls["Provider"].setValue(selected);
    }


    onSubmit() {
        //this.activeModal.close();
        //  return;
       
        if (this.form.valid) {
            this.sendLogin(this.form.controls["Username"].value, this.form.controls["Password"].value, this.form.controls["Provider"].value);
        }
    }

    sendLogin(username: string, password: string, provider:string) {
        this.userName = username;
        this.userPassword = password;
        this.currentProvider = provider;
        this.workspaceService.data.sendLogin(username, password,"" , provider);

        this.activeModal.close();
        this.workspaceService.data.LoginModalCreated = false;
    }

    getFormControl(name: string) {
        return this.form.get(name);
    }

    // returns TRUE if the FormControl is valid
    isValid(name: string) {
        var e = this.getFormControl(name);
        return e && e.valid;
    }

    // returns TRUE if the FormControl has been changed
    isChanged(name: string) {
        var e = this.getFormControl(name);
        return e && (e.dirty || e.touched);
    }

    // returns TRUE if the FormControl is invalid after user changes
    hasError(name: string) {
        var e = this.getFormControl(name);
        return e && (e.dirty || e.touched) && !e.valid;
    }

    public isRemember() {
        this.workspaceService.data.remember = !this.workspaceService.data.remember;
    }

    public runDoShortcut() {
        myMethod();
    }

    public onKey(event: any) {
        if (event.code == "Space" || event.cod == "Enter") {
            this.isRemember();
        }
    }

    get liveAccount (): boolean {
        return this.dataService.LiveAccount;
    }

    public get accountPrefix()
    {
        if(this.form.controls["Provider"].value=="OANDA")
        {
            return "PremiereTrade"; 
        }
        else
        {
           return "";
        }
       
    }

    public get debugVisibility()
    {
        return this.dataService.DebugVisibility;
    }
}
